import { Component, OnInit, Injector, Output, EventEmitter } from '@angular/core';
import { FormGridComponent } from 'src/modules/base/components/form-grid/form-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';

@Component({
    selector: 'app-insurance-billing-form-grid',
    templateUrl: '../../../base/components/form-grid/form-grid.component.html',
    standalone: false
})
export class InsuranceBillingFormGridComponent extends FormGridComponent {
  @Output() bannerRefreshClick = new EventEmitter<any>();

  constructor(
    public route: ActivatedRoute,
    public injector: Injector,
    router: Router,
    public asideBarService: AsideBarService
  ) {
    super(route, injector, router, asideBarService)
  }
  refreshGridBanner(event)
  {
    this.bannerRefreshClick.emit(event);
    this.bindGrid();
  }
  bindGrid(resource?, application?, type?, queryId?) {
    this.loader.showSpinner();
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
    if (this._currentData.parameters) {
      gridData['parameters'] = this._currentData.parameters;
    }

    if (queryId == undefined || queryId == '') {
      gridData['query_id'] = this._currentData.resouceDef.query_id == undefined ? "GET_PAGE" : this._currentData.resouceDef.query_id;
    } else { gridData['query_id'] = queryId == undefined ? "GET_PAGE" : queryId; }

    if (this._currentData.APIresource) {
      resource = this._currentData.APIresource.resource;
      application = this._currentData.APIresource.application;
      gridData['query_id'] = this._currentData.APIresource.query_id;
    }
    resource = (resource == '' || resource == undefined) ? this._currentData.resource : resource;
    this.baseService.getData(gridData, "", resource, application).subscribe(
      (data: any) => {
        if (data.erroCode == -1) {
          this.alerts.error(data.message);
          if (type == undefined || type == '') {
            this._currentData.dataList = [];
          }

        } else {
          if (type == undefined || type == '') {
            this._currentData.dataList = data;
            this.bannerRefreshClick.emit({"button": this._currentData.currentAction});
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    );
  }
}
